"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _lodash = _interopRequireDefault(require("lodash"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CollectionService = /*#__PURE__*/function () {
  function CollectionService() {
    _classCallCheck(this, CollectionService);
  }

  _createClass(CollectionService, null, [{
    key: "isAddCollectionRequestValid",

    /*
      Validation
    */
    value: function isAddCollectionRequestValid(addCollectionRequest) {
      if (addCollectionRequest === null || addCollectionRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        alternativeId: _joiBrowser["default"].string().min(1).max(100).allow(null),
        name: _joiBrowser["default"].string().min(2).max(100).required(),
        unit: _joiBrowser["default"].string().min(2).max(50).allow(null),
        mappedTagId: _joiBrowser["default"].number().integer().allow(null),
        insufficientDataEventTemplate: _joiBrowser["default"].number().integer().allow(null),
        insufficientDataTimePeriod: _joiBrowser["default"].number().integer().allow(null)
      });

      return _joiBrowser["default"].validate(addCollectionRequest, schema).error === null;
    }
  }, {
    key: "isEditCollectionRequestValid",
    value: function isEditCollectionRequestValid(editCollectionRequest) {
      if (editCollectionRequest === null || editCollectionRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        alternativeId: _joiBrowser["default"].string().min(1).max(100).allow(null),
        name: _joiBrowser["default"].string().min(2).max(100).allow(null),
        unit: _joiBrowser["default"].string().min(2).max(50).allow(null),
        mappedTagId: _joiBrowser["default"].number().integer().allow(null),
        removeMappedTag: _joiBrowser["default"]["boolean"]().allow(null),
        insufficientDataEventTemplate: _joiBrowser["default"].number().integer().allow(null),
        insufficientDataTimePeriod: _joiBrowser["default"].number().integer().allow(null)
      });

      return _joiBrowser["default"].validate(editCollectionRequest, schema).error === null;
    }
    /*
      Service Methods
    */

  }, {
    key: "getCollections",
    value: function getCollections(pagination) {
      var url = "?page=".concat(pagination.page, "&size=").concat(pagination.size, "&search=").concat(pagination.search);

      _lodash["default"].forEach(pagination.sort, function (value) {
        url = url.concat("&sort=".concat(value));
      });

      return this.httpService.get(url);
    } // static getDatapointsForCollection(collectionId, pagination) {
    //   if (!Number.isInteger(collectionId)) {
    //     return Promise.reject(new Error('Missing Collection ID'));
    //   }
    //   let url = `/${collectionId}/datapoints?page=${pagination.page}&size=${pagination.size}`;
    //   _.forEach(pagination.sort, (value) => {
    //     url = url.concat(`&sort=${value}`);
    //   });
    //   return this.httpService.get(url);
    // }

  }, {
    key: "addCollection",
    value: function addCollection(addCollectionRequest) {
      var _this = this;

      if (!CollectionService.isAddCollectionRequestValid(addCollectionRequest)) {
        return Promise.reject(new Error('Invalid add collection request'));
      }

      return new Promise(function (resolve, reject) {
        _this.httpService.post('/', addCollectionRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "editCollection",
    value: function editCollection(collectionId, editCollectionRequest) {
      var _this2 = this;

      if (!Number.isInteger(collectionId)) {
        return Promise.reject(new Error('Missing Collection ID'));
      }

      if (!CollectionService.isEditCollectionRequestValid(editCollectionRequest)) {
        return Promise.reject(new Error('Invalid edit collection request'));
      }

      return new Promise(function (resolve, reject) {
        _this2.httpService.patch("/".concat(collectionId), editCollectionRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "deleteCollection",
    value: function deleteCollection(collectionId) {
      var _this3 = this;

      if (!Number.isInteger(collectionId)) {
        return Promise.reject(new Error('Missing Collection ID'));
      }

      return new Promise(function (resolve, reject) {
        _this3.httpService["delete"]("/".concat(collectionId)).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }]);

  return CollectionService;
}();

exports["default"] = CollectionService;
CollectionService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_DATAPOINT_METADATA_API : '', "/collections")
});